PLAN_SKU_BULK_GIFT_ANNUAL